import createLoginGatekeeper from '@vcd-ecm-ui/LoginGatekeeper/src';
import { TokenCache } from '@vcd-ecm-ui/LoginGatekeeper/src/hooks/createLoginGatekeeper';
import { AuthUrlFactory, AuthUrls, IdPType } from '../shared-types/auth/AuthUrlFactory';

const useLoginGatekeeper = (): [boolean, TokenCache, AuthUrls] => {
  // Always use Auth0
  const authUrls = AuthUrlFactory.create(IdPType.AUTH0);

  const [isLoggedIn, tokenCache] = createLoginGatekeeper(authUrls.getLoginUrl())();

  return [isLoggedIn, tokenCache, authUrls];
};

export default useLoginGatekeeper;
